<section id="speed">
    <div class=shoe-type>
        <h2 tabindex="0">Speed</h2>
        <p tabindex="0">Lightweight, responsive, and built for racing and faster runs! Lightweight trainers prioritize speed and weight over marshmellow cushioning and rigid stability, but that doesn't mean they are inherently less comfortable! These shoes are ideal for people who want a light, firm, and responsive ride and looking to run faster mileage.</p>
        <div class="check-out">
            <h3 tabindex="0">Be sure to check out...</h3>
            <div class="row">
                <ng-container *ngFor="let shoe of speedShoes">
                    <div class="col-lg-4">
                        <app-shoe-card [shoe]="shoe"></app-shoe-card>         
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>